module.exports = __webpack_public_path__ + "img/yw-1.cd163971.svg";